var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m843 1028-92-92H180q-24.75 0-42.375-17.625T120 876V305l-82-82 43-43 805 805-43 43ZM180 876h511L571 756H240l120-140 80 109 46-55-306-306v512Zm660-22-60-60V276H262l-60-60h578q24.75 0 42.375 17.625T840 276v578ZM524 538Zm-88 83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOff);
export default __webpack_public_path__ + "static/media/image_off.9453c57d9e1d2b625ebe8a157e8450a8.svg";
export { ForwardRef as ReactComponent };